webpackJsonp([132339944140454],{

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _metaData = __webpack_require__(14);
	
	var _metaData2 = _interopRequireDefault(_metaData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// INTERFACE
	// LIBS
	var query = exports.query = '** extracted graphql fragment **';
	
	// COMPONENTS
	
	exports.default = function (_ref) {
	  var data = _ref.data,
	      location = _ref.location;
	
	  if (!data.pageJson) return _react2.default.createElement(
	    'div',
	    { className: 'ut-oh' },
	    ' '
	  );
	  var _data$pageJson = data.pageJson,
	      title = _data$pageJson.title,
	      content = _data$pageJson.content,
	      metaDescription = _data$pageJson.metaDescription,
	      slug = _data$pageJson.slug;
	
	
	  return _react2.default.createElement(
	    'div',
	    { itemScope: true, itemType: 'http://schema.org/WebPage', className: 'legacyPage' },
	    _react2.default.createElement(_metaData2.default, { data: data.pageJson }),
	    _react2.default.createElement(
	      'div',
	      { className: 'custom_pages' },
	      _react2.default.createElement('div', { itemType: 'mainContentOfPage', className: 'markdown', dangerouslySetInnerHTML: { __html: content } })
	    )
	  );
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-page-index-js-80e21032711e6fc41d2b.js